import { TechnologicalMap } from './TechnologicalMap.main';

export { TechnologicalMap };
